module.exports = __webpack_public_path__ + "assets/clock_alert-6f2f04.svg";